import styled from "@emotion/styled";
import { Field } from "@ui-kit/Field";

export const StyledField = styled(Field)`
	& > div:first-child {
		width: 30%;
	}
`;
